let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("T3Eou")).then(() => parcelRequire('43TWg'));